export const BENEFITS = [
    {
        title: 'Efficient',
        text: 'Eliminating the traditional manufacturing process and producing on-demand means less waste and higher sustainability, as well as lower costs and higher profit margins.',
        image: '/img/benefit-icons/efficient.svg'
    },
    {
        title: 'Measurable',
        text: 'Product delivery via CAPSULAB enables the manufacturer to capture an enormous amount of user behavior data, traditionally out of reach when working through a retailer, creating greater satisfaction, loyalty, and customer lifetime value.',
        image: '/img/benefit-icons/measurable.svg'
    },
    {
        title: 'Quality',
        text: 'Providing a superior product at the same or lower cost: always personalized, always fresh.',
        image: '/img/benefit-icons/quality.svg'
    },
    {
        title: 'Various',
        text: 'CAPSULAB gives brands a new way to serve their products to consumers.',
        image: '/img/benefit-icons/various.svg'
    },
    {
        title: 'Scalable',
        text: 'Major category extensions for core brands into additional categories can be created through the integration of CAPSULAB.',
        image: '/img/benefit-icons/scalable.svg'
    }
]
